import { z } from 'zod'

export const PopupTypeEnum = z.enum(['HOME', 'SPOTS', 'REWARDS', 'AR_PHOTO_FRAME', 'RESTORE'])
export type PopupType = z.infer<typeof PopupTypeEnum>

export const PopupItemDataSchema = z.object({
  image: z.string().nullable().describe('ポップアップ画像URL'),
  url: z.string().nullable().describe('クリック時の遷移先URL'),
})
export type PopupItemData = z.infer<typeof PopupItemDataSchema>

export const PopupTypeDataSchema = z.object({
  type: PopupTypeEnum.describe('ポップアップタイプ'),
  item: z.array(PopupItemDataSchema).describe('ポップアップアイテム一覧'),
})
export type PopupTypeData = z.infer<typeof PopupTypeDataSchema>

export const PopupGetResponseSchema = z.object({
  popup: z.array(PopupTypeDataSchema),
})
export type PopupGetResponse = z.infer<typeof PopupGetResponseSchema>
